import { useCallback } from "react"
import { LineRecord, NodeState } from "../services/modal"
import { getSimUnitData } from "@/services/project/simulation.service"
import { useSelector } from "react-redux"
import { getProjectPropertySets } from "@/store/project/selector"

export function useGetUnitComponents() {
  const propertySets = useSelector(getProjectPropertySets) || []
  return useCallback(async (unit: NodeState | LineRecord, simId) => {
    try {
      const unitData = await getSimUnitData({sId: simId, id: unit.id})
      const setName = unitData.args.tpps
      const propertySet = propertySets.find(item => item.name === setName)
      if (!propertySet) {
        return []
      }
      return propertySet.components
    } catch (err) {
      return []
    }
  }, [propertySets])
}